import { carouselItems } from '@/mocks/homeMangaData';

const images = [
  'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20Korean%20webtoon%20style%20with%20vibrant%20colors%20dynamic%20action%20scenes%20fantasy%20warriors%20and%20romantic%20characters%20floating%20manga%20panels%20warm%20golden%20and%20coral%20tones%20editorial%20composition%20high%20detail%20stylized&width=960&height=540&seq=carousel-kr&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20classic%20Japanese%20manga%20aesthetics%20with%20samurai%20ninja%20school%20life%20scenes%20iconic%20manga%20panel%20layouts%20warm%20nostalgic%20lighting%20cream%20background%20stylized%20editorial%20composition%20with%20soft%20shadows&width=960&height=540&seq=carousel-jp&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20Chinese%20manhua%20style%20with%20traditional%20ink%20wash%20painting%20elements%20martial%20arts%20xianxia%20fantasy%20characters%20dynamic%20brushstroke%20aesthetics%20warm%20earthy%20tones%20editorial%20composition&width=960&height=540&seq=carousel-cn&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20fresh%20new%20manga%20releases%20with%20colorful%20covers%20summer%20themed%20bright%20vibrant%20energy%20floating%20book%20covers%20warm%20sunlight%20clean%20modern%20editorial%20composition%20with%20inviting%20atmosphere&width=960&height=540&seq=carousel-new&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">深度专题策划，带你发现漫画世界的无限精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={images[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}